import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import {
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  NgModule,
  Optional,
  SecurityContext,
  SkipSelf,
} from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import {
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { es } from 'date-fns/locale';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { provideMarkdown } from 'ngx-markdown';
import { QuillModule } from 'ngx-quill';
import { GoogleReCaptchaEnvironment } from 'src/environments/environment';
import { httpInterceptorProviders } from './interceptors/http-interceptors-provider';
import { LanguageEnum } from './types/language/language.enum';
import { PaginatorIntl } from './types/paginator-intl/paginator-intl';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      defaultLanguage: LanguageEnum.default,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatDialogModule,
    MatSnackBarModule,
    MatTooltipModule,
    RecaptchaV3Module,
    QuillModule.forRoot(),
  ],
  providers: [
    httpInterceptorProviders,
    provideMarkdown({
      sanitize: SecurityContext.HTML,
    }),
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        horizontalPosition: 'center',
        verticalPosition: 'top',
      },
    },
    {
      provide: MAT_DATE_LOCALE,
      useClass: DateFnsAdapter,
      useValue: es,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: GoogleReCaptchaEnvironment.sitekey,
    },
    { provide: MatPaginatorIntl, useClass: PaginatorIntl },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}

registerLocaleData(localeEs, 'es');

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
